import type { ConfiguredCombo } from "@/store/selection";
import type { WindowFabricColor } from "@/store/selection";
import type { ProductType } from "@/models/product";
import type { SunProtectionProductInput } from "../order.types";

export function mapSelectionsToProductInputs(
    selectedProductIds: string[],
    selectedTypeId: string,
    selectedCategory: ProductType,
    windowSelections: Record<string, WindowFabricColor>,
): SunProtectionProductInput[] {
    return selectedProductIds.flatMap((productId) => {
        const sel = windowSelections[productId];
        if (!sel?.colorId) return [];
        return [
            {
                productId,
                sunProtectionProductId: selectedTypeId,
                productType: selectedCategory,
                colorId: sel.colorId,
                frameColorId: sel.frameColorId ?? null,
                // Backend requires controlType on every input. UI only exposes
                // a choice for sun-protection windows; window-decoration
                // windows fall back to REMOTE.
                controlType: sel.controlType ?? "REMOTE",
            },
        ];
    });
}

export function mapCombosToProductInputs(
    combos: ConfiguredCombo[],
): SunProtectionProductInput[] {
    return combos.flatMap((combo) =>
        mapSelectionsToProductInputs(
            combo.selectedProductIds,
            combo.typeId,
            combo.category,
            combo.windowSelections,
        ),
    );
}
